import { lazy } from 'react';

export default [
  {
    path: 'catalog/control-products',
    component: lazy(() => import('views/control-products')),
  },
];
